export default "__VITE_ASSET__BI6r8K2$__"